export const ICONS_REF: {[key: string]: {viewBox: string, path: string}} = {
  alert_st: {
    viewBox: '0 0 80 70',
    path: '<path d="M8.39 28.66v13.68M71.33 9.5v52m0-2.74L8.39 39.6v-8.21l62.94-19.15v46.52z"/><path d="M41.23 50.86a9.58 9.58 0 0 1-19.16 0v-7.15"/>'
  },
  angle_left_st: {
    viewBox: '0 0 44 70',
    path: '<path d="M33.5 61.5l-26-26 26-26"/>'
  },
  angle_down_st: {
    viewBox: '0 0 72 69',
    path: '<path d="M62 22.5l-26 26-26-26"/>'
  },
  angle_right_st: {
    viewBox: '0 0 44 70',
    path: '<path d="M8.5 61.5l26-26-26-26"/>'
  },
  angle_up_st: {
    viewBox: '0 0 72 69',
    path: '<path d="M10 46.5l26-26 26 26"/>'
  },
  arrow_down_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M60.6 35.99l-25.5 25.5-25.51-25.5m25.6-26.5V60.5"/>'
  },
  arrow_left_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M34.99 60.9l-26-26 26-26M62 35H10"/>'
  },
  arrow_right_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M36.01 9.1l26 26-26 26M9 35h52"/>'
  },
  check: {
    viewBox: '0 0 86 70',
    path: '<path d="M30.35 50.63l-16.3-16.29-5.43 5.43L30.35 61.5l46.57-46.57-5.44-5.43z"/>'
  },
  arrow_up_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M9.59 35L35.1 9.49 60.6 35M35 61.49v-51"/>'
  },
  close_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M61.21 60.5l-52-52m52 0l-52 52"/>'
  },
  code_st: {
    viewBox: '0 0 83 70',
    path: '<path d="M36.39 61.5h38.08M9.52 9.5l26.76 23.85L9.52 56.66"/>'
  },
  collapse_st: {
    viewBox: '0 0 69 69',
    path: '<path d="M37.63 31.04l21.21-21.2M10.07 58.61l21.2-21.21m21.21-6.36H37.63V16.2m-6.36 36.04V37.4H16.43m21.2 0l21.21 21.21M10.07 9.84l21.2 21.2m6.36 21.2V37.4h14.85m-36.05-6.36h14.84V16.2"/>'
  },
  color: {
    viewBox: '0 0 70 70',
    path: '<path d="M33.25 60.18a6.54 6.54 0 0 1-4.65-1.92L14 43.65A6.44 6.44 0 0 1 12.07 39 6.53 6.53 0 0 1 14 34.35l16.53-16.53-4.42-4.42a1.93 1.93 0 0 1 2.73-2.72l24.91 24.91a4.83 4.83 0 0 1 0 6.82L37.91 58.26a6.57 6.57 0 0 1-4.66 1.92zm0-39.64L16.72 37.07a2.7 2.7 0 0 0-.8 1.93 2.57 2.57 0 0 0 .8 1.93l14.61 14.6a2.78 2.78 0 0 0 3.85 0L51 39.69a1 1 0 0 0 0-1.37zM49.62 57c0-3.71 4.13-6.61 4.82-10.27.69 3.67 4.81 6.58 4.81 10.27a4.83 4.83 0 1 1-9.63 0zm2.83-16L36.54 56.9a4.67 4.67 0 0 1-6.58 0l-14.6-14.61A8.2 8.2 0 0 1 14 39h37.62a1.17 1.17 0 0 1 .83 2z"/>'
  },
  cursor_st: {
    viewBox: '0 0 59 70',
    path: '<path d="M19.74 41.69V13.21a3.71 3.71 0 1 1 7.42 0v11.15h5a2.48 2.48 0 0 1 2.47 2.47h4.95A2.48 2.48 0 0 1 42 29.31h3.72A3.71 3.71 0 0 1 49.45 33v7.7a24.81 24.81 0 0 1-1 6.8l-4 14H22.21C18.5 56.55 8.8 40 8.8 40a3 3 0 0 1 4.36-4zm14.85-14.86v4.96m-7.43-8.67v8.67m14.86-2.48v4.95"/>'
  },
  date: {
    viewBox: '0 0 69 70',
    path: '<path d="M43.33 46.33H39.4v3.92h3.93zM36.46 32.6h-3.92v3.92h3.92zm6.87 6.86H39.4v3.93h3.93zm0-6.86H39.4v3.92h3.93zm6.86 0h-3.92v3.92h3.92zm0 6.86h-3.92v3.93h3.92zm-13.73 0h-3.92v3.93h3.92zM29.6 32.6h-3.93v3.92h3.93zm-6.87 6.86h-3.92v3.93h3.92zm6.87 6.87h-3.93v3.92h3.93zm-6.87 0h-3.92v3.92h3.92zm6.87-6.87h-3.93v3.93h3.93zm6.86 6.87h-3.92v3.92h3.92zM49.39 14.2V10h-3.84v4.2h-22.1V10h-3.84v4.2h-7.16A2.48 2.48 0 0 0 10 16.7v40.8a2.48 2.48 0 0 0 2.45 2.5h44.1A2.48 2.48 0 0 0 59 57.5V16.7a2.48 2.48 0 0 0-2.45-2.5zm4.09 41.19h-38a.87.87 0 0 1-.86-.89V27.37h39.73v27.12a.88.88 0 0 1-.87.9zm.87-30.73H14.58v-5.57a.82.82 0 0 1 .87-.76h4.16v1.58h3.84v-1.58h22.1v1.58h3.84v-1.58h4.09a.82.82 0 0 1 .87.76z"/>'
  },
  delete_st: {
    viewBox: '0 0 68 70',
    path: '<path d="M15.63 16.28H51.8V61.5H15.63zm9.04-6.78h18.09v6.78H24.67zM9.98 16.28h49.74M24.67 24.2v27.13m9.05-27.13v27.13m9.04-27.13v27.13"/>'
  },
  download: {
    viewBox: '0 0 61 70',
    path: '<path d="M52.91 27.85H40.68V9.5H22.32v18.35H10.09L31.5 49.26zM10.09 55.38v6.12h42.82v-6.12z"/>'
  },
  download_data_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M42.38 49.06l5.65 5.66 5.65-5.66"/><circle cx="48.03" cy="47.93" r="13.57"/><path d="M48.03 41.15v13.57m4.52-36.12c0 5-9.61 9-21.47 9S9.6 23.59 9.6 18.6s9.61-9.1 21.48-9.1 21.47 4.1 21.47 9.1zM31.08 36.69c-11.87 0-21.48-4.06-21.48-9m18.08 19.05C17.44 46.06 9.6 42.32 9.6 37.82"/><path d="M28.81 57C18 56.48 9.6 52.66 9.6 48V18.54m42.95 0v10.18"/>'
  },
  drag_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M9.5 49.5h50m-50-30h50m-50 15h50"/>'
  },
  edge_st: {
    viewBox: '0 0 70 70',
    path: '<circle cx="51" cy="19.48" r="9.98"/><circle cx="18.89" cy="51.58" r="9.92"/><path d="M43.94 26.53L25.9 44.57"/>'
  },
  earth: {
    viewBox: '0 0 70 70',
    path: '<path d="M46.43 21.12l.05.37-.55.12-.08.79h.67l.89-.09.45-.54-.48-.19-.27-.31-.4-.64-.19-.92-.75.15-.21.32v.37l.36.25.51.32z"/><path d="M45.79 21.43l.04-.5-.44-.19-.62.14-.45.74v.47h.53l.94-.66zm-12.7 2.1l-.13.35h-.66v.34h.16v.17h.4l.26-.15.06-.32h.33l.13-.26-.3-.07zm-1.69.62l-.02.33.47-.04.05-.33-.29-.23-.21.27z"/><path d="M60 34.74c0-.73 0-1.46-.11-2.17a25 25 0 0 0-1.65-6.81c-.07-.16-.13-.32-.19-.48a25.25 25.25 0 0 0-4.7-7.28l-.35-.37q-.55-.57-1.14-1.11a25 25 0 0 0-33.75.1 25.54 25.54 0 0 0-2.85 3.12 25 25 0 1 0 42 26.62 24.43 24.43 0 0 0 2-5.51c.12-.49.22-1 .31-1.48A25.19 25.19 0 0 0 60 35v-.26zm-4.7-10l.14-.16c.19.37.37.74.54 1.12h-.24l-.44.06zm-3.61-4.36v-1.11c.39.42.77.85 1.13 1.29l-.45.67h-1.58l-.1-.33zm-30.17-2.77H22v-.17h.82v.36l-.23.31h-1.07v-.46zm.8 1.12l.54-.09c.05 0 0 .5 0 .5l-1.13.07-.21-.21zm34.56 9.92h-1.83l-1.11-.83-1.18.12v.71h-.37l-.4-.28-2-.52v-1.32l-2.57.21-.8.42h-1l-.51-.05-1.24.69v1.3l-2.53 1.83.21.78H42l-.13.75-.37.13v1.94L43.69 37h1l.06-.15h1.71l.5-.46h1l.54.54 1.45.15-.28 1.92 1.61 2.84-.85 1.62.06.77.67.66v1.84l.84 1.21v1.52h.75A22.93 22.93 0 0 1 13.89 26v-.7l.82-1c.28-.54.59-1.06.91-1.57v.41l-.95 1.16c-.3.56-.57 1.13-.82 1.71v1.31l.95.46v1.82l.92 1.56.74.11.1-.53-.88-1.35-.17-1.32h.51l.22 1.35 1.27 1.85-.33.6.82 1.23 2 .5v-.32l.8.11-.08.57.63.12 1 .26 1.38 1.57 1.75.13.17 1.43-1.2.84-.06 1.28-.17.78L26 42.54l.13.74s.63.18.71.18 1.41 1 1.41 1v3.92l.47.14-.32 1.81.8 1.07-.2 1.8 1.06 1.86 1.36 1.19h1.36l.14-.44-1-.84.06-.42.18-.51v-.53h-.68l-.34-.43.56-.54.08-.41-.59-.13v-.38l.89-.14 1.37-.65.45-.84 1.43-1.83-.32-1.43.44-.76h1.31l.89-.71.35-2.77 1-1.24.17-.81-.9-.28-.59-1h-2l-1.68-.6-.08-1.15-.53-.93h-1.45l-.84-1.32-.74-.36v.4l-1.36.06-.5-.69-1.41-.29-1.16 1.35-1.83-.31-.1-2.06-1.38-.26.53-1-.15-.57-1.75 1.18-1.11-.14-.39-.86.24-.89.61-1.12 1.4-.71h2.71v.82l1 .46-.08-1.41.71-.71 1.41-.93.1-.65L29.22 25l1.5-.83-.13-.11 1-1 .37.1.17.21.39-.42h.09l-.42-.05-.43-.15v-.41l.23-.19h.5l.23.11.2.4h.31l.7-.11.1-.34.41.1v.37l-.38.26.06.4 1.27.4h.29v-.55l-1-.46-.06-.27.84-.29v-.8l-.88-.53-.06-1.35-1.2.59H33l.12-1-1.64-.39-.67.51v1.56l-1.22.39-.49 1-.53.09v-1.3l-1.14-.16-.57-.37-.23-.84 2-1.2 1-.3.11.67h.55v-.34l.58-.08v-.12l-.25-.1-.06-.36.72-.06.43-.45.13-.14 1.51-.19.66.57-1.74.93 2.22.52.29-.74h1l.34-.65-.68-.17v-.82l-2.16-1-1.49.18L31 16v1.07l-.81-.07-.14-.59.84-.77-1.52-.07-.44.13-.19.52.57.09-.11.57-1 .06-.15.38h-1.41a4.36 4.36 0 0 0-.09-.8h1.1l.84-.82-.46-.23-.61.59h-1l-.61-.84h-1.28l-1.36 1h1.24l.12.36-.33.3h1.38l.21.49-1.55-.05-.07-.39-1-.21-.51-.28h-1.14a22.89 22.89 0 0 1 28.63 1.34l-.28.49-1 .41-.45.48.1.57.55.07.33.83.94-.38.15 1.1h-.28l-.77-.12-.86.15-.83 1.17-1.19.19-.17 1 .5.12-.14.65-1.18-.23-1.08.23-.23.61.19 1.26.63.3h1.06l.72-.07.22-.57 1.13-1.46.73.15.73-.65.14.51 1.79 1.21-.22.29h-.81l.31.44.5.11.58-.24v-.71l.26-.12-.22-.25-1.19-.67-.32-.89h1l.32.32.86.74v.89l.89.94.33-1.29.61-.34.12 1.06.6.66h1.19c.24.59.44 1.2.63 1.82zm-33.24-7.29l.6-.29.54.13-.19.73-.58.19zm3.18 1.71v.48h-1.37l-.51-.15.13-.33.65-.27h.91v.27zm.63.66v.46l-.34.22-.43.08v-.76zm-.38-.18V23l.47.43zm.21 1.1v.44l-.33.33h-.72l.11-.5h.34l.07-.17zm-1.81-.92h.75l-1 1.36-.4-.21.09-.58zm3.1.76v.44h-.73l-.2-.28v-.42h.06zm-.67-.61l.2-.22.35.22-.28.23zm29.35 5.93l.08-.08c0 .13.06.25.09.39z"/><path d="M13.89 25.3v.7c.25-.58.52-1.15.82-1.71z"/>'
  },
  edit_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M23.47 58.27L8.63 61.76l3.48-14.84L47.92 11.1a4.61 4.61 0 0 1 6.5 0l4.87 4.9a4.59 4.59 0 0 1 0 6.49zm34.2-34.18L46.3 12.72m8.09 14.65l-11.34-11.4m-19 41.73L12.69 46.34"/>'
  },
  erase: {
    viewBox: '0 0 70 70',
    path: '<path d="M34.62 10a25 25 0 1 0 25 25 25 25 0 0 0-25-25zm0 45a20 20 0 1 1 20-20 20 20 0 0 1-19.97 20zM46.5 38h-24a2.5 2.5 0 0 1-2.5-2.5 2.5 2.5 0 0 1 2.5-2.5h24a2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1-2.5 2.5z"/>'
  },
  erase_st: {
    viewBox: '0 0 76 69',
    path: '<path d="M39.7 12.61L11.18 41.12a8.9 8.9 0 0 0 0 12.58l4.62 4.61h23.48l23.06-23.06a8.88 8.88 0 0 0 0-12.58L52.28 12.61a8.88 8.88 0 0 0-12.58 0zm-8.8 8.8l22.64 22.65M15.8 58.31h50.32"/>'
  },
  error: {
    viewBox: '0 0 31 70',
    path: '<path d="M20.5 55.69a4.5 4.5 0 0 1-1.5 3.37 5.06 5.06 0 0 1-7 0 4.5 4.5 0 0 1-1.46-3.37A4.63 4.63 0 0 1 12 52.28a5 5 0 0 1 7 0 4.63 4.63 0 0 1 1.5 3.41zm-.33-40.84q0 1.67-1.19 11.21t-2.1 18.44h-2.82q-.8-8.91-2-18.44t-1.15-11.21a4.33 4.33 0 0 1 1.31-3.2 4.48 4.48 0 0 1 3.32-1.3 4.57 4.57 0 0 1 3.33 1.28 4.33 4.33 0 0 1 1.3 3.22z"/>'
  },
  expand_st: {
    viewBox: '0 0 69 69',
    path: '<path d="M37.73 31.75l20.68-20.68M10.84 58.64l20.68-20.68m-7.07 21.55H9.97V45.03m49.31-20.36V10.2H44.8m-7.07 27.76l20.68 20.68M10.84 11.07l20.68 20.68M9.97 24.67V10.2h14.48M44.8 59.51h14.48V45.03"/>'
  },
  export_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M57.49 37v17.7a6.79 6.79 0 0 1-6.8 6.8h-35a6.79 6.79 0 0 1-6.8-6.8V19.64a6.79 6.79 0 0 1 6.8-6.79h18.6m-.41 23.61L60.84 9.5m0 10.62V9.5H50.21"/>'
  },
  file_add_st: {
    viewBox: '0 0 70 70',
    path: '<circle cx="47.83" cy="47.93" r="13.57"/><path d="M42.17 47.93h11.31m-5.65 5.66V42.28M32 56.98H9.39V9.5h24.87l11.3 11.3v9.05"/><path d="M34.26 9.5v11.3h11.3"/>'
  },
  file_download_st: {
    viewBox: '0 0 61 70',
    path: '<path d="M23.05 41.85l8.32 8.32 8.32-8.32m-8.21-11.54v19.86"/><path d="M52.14 61.5H9.18v-52h29.39l13.57 13.57V61.5z"/><path d="M38.57 9.5v13.57h13.57"/>'
  },
  file_st: {
    viewBox: '0 0 61 70',
    path: '<path d="M52.14 61.5H9.18v-52h29.39l13.57 13.57V61.5z"/><path d="M38.57 9.5v13.57h13.57"/>'
  },
  filter: {
    viewBox: '0 0 96 70',
    path: '<path d="M39.15 61.5h17.33v-8.67H39.15zM8.81 9.5v8.67h78V9.5zm13 30.33h52v-8.66h-52z"/>'
  },
  focus: {
    viewBox: '0 0 71 70',
    path: '<path d="M47 10.17v4.16h7.8a2.08 2.08 0 0 1 2.08 2.08v7.8H61v-12a2.08 2.08 0 0 0-2.08-2.08zM22.42 34.79A12.79 12.79 0 1 0 35.21 22a12.81 12.81 0 0 0-12.79 12.79zm-6.19-20.46H24v-4.16H12a2.07 2.07 0 0 0-2 2.07v12h4.16V16.4a2.07 2.07 0 0 1 2.07-2.07zM14.16 46H10v12a2.08 2.08 0 0 0 2.08 2H24v-4.16h-7.8a2.08 2.08 0 0 1-2.08-2.08zm40.6 9.84H47V60h12a2.08 2.08 0 0 0 2-2.08V46h-4.16v7.8a2.08 2.08 0 0 1-2.08 2.04z"/>'
  },
  folder: {
    viewBox: '0 0 83 70',
    path: '<path d="M35.1 9.5H15.6A6.49 6.49 0 0 0 9.13 16v39a6.51 6.51 0 0 0 6.5 6.5h52A6.52 6.52 0 0 0 74.1 55V22.5a6.53 6.53 0 0 0-6.5-6.5h-26z"/>'
  },
  folder_add_st: {
    viewBox: '0 0 70 70',
    path: '<circle cx="47.44" cy="47.93" r="13.57"/><path d="M41.78 47.93h11.31m-5.65 5.66V42.28m2.26-19.8V14H20.31V9.5H9v35a3.39 3.39 0 1 0 6.78 0V22.48h38.44v6.24M12.39 47.93h15.83"/>'
  },
  folder_st: {
    viewBox: '0 0 81 70',
    path: '<path d="M16.22 61.48h47.89a8.22 8.22 0 0 0 8.21-8.21V28.35H23.06v26.29a6.84 6.84 0 0 1-13.68 0V9.48h19.16V15h35.57v13.4"/>'
  },
  fullscreen_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M38.35 32.34l21.81-21.81M9.99 60.7L31.8 38.89m-7.46 22.73H9.07V46.35m52-21.47V9.62H45.81"/>'
  },
  geo: {
    viewBox: '0 0 70 70',
    path: '<path d="M35.18 9.5a26 26 0 1 1-26 26 26 26 0 0 1 26-26zm19.51 19.11c-.12-.5-.24-1-.35-1.5a1 1 0 0 0-.9-.91c-.26 0-.32-.15-.36-.38-.14-.83-.34-1.65-.45-2.48a.74.74 0 0 0-.71-.73c-1.18-.24-1.24-.33-1.42-1.51v-.08c-.14-.9-.14-.93-1-1.1a2.79 2.79 0 0 1-2.14-1.52c-.12-.24-.32-.45-.44-.69a.41.41 0 0 0-.56-.22 1.59 1.59 0 0 1-1.65-.5 9.29 9.29 0 0 0-.83-.83 1.47 1.47 0 0 0-.73-.38c-1.75-.27-1.55-.18-2-1.75a.67.67 0 0 0-.56-.54 22.47 22.47 0 0 0-13.99 1.06c-1.9.78-1.63.41-2.24 2.36l-.09.24a4.73 4.73 0 0 1-1.92 2.07 11.62 11.62 0 0 0 0-1.19c-.08-.76-.44-.91-1-.43-7.31 6.06-10.21 13.8-8.15 23a22.46 22.46 0 0 0 26.52 17 .52.52 0 0 0 .5-.48 6.49 6.49 0 0 1 .5-2.05c.7-1.19-.45-3-1.73-3.15a2.49 2.49 0 0 0-.76.08 2.37 2.37 0 0 0-.52.27c.1-.77.17-1.44.3-2.11a1.23 1.23 0 0 1 .38-.75 2.71 2.71 0 0 0 1-1.91 1 1 0 0 1 .35-.48c.25-.2.59-.29.79-.51a2.82 2.82 0 0 1 1.41-.89 5.85 5.85 0 0 1 3.74.2 4.38 4.38 0 0 1 .74.5.87.87 0 0 0 .41.2c.48 0 1 0 1.43-.09a1.71 1.71 0 0 1 1.78.91c0 .06.08.12.11.17 1.84-.43 2-.43 2.41-.1-.69.18-1.41.22-1.73 1.06-.19.49-.18.9.33 1.09a4.1 4.1 0 0 0 .6.14l.24.88a22 22 0 0 0 5.5-11 21.67 21.67 0 0 0-.7-10.83l-.47 1.46a4.47 4.47 0 0 1-.37-1c-.32-.71-.42-.77-1.27-.6z"/><path d="M36.79 20.86c-.66-.39-1-.15-1.08.56a1.79 1.79 0 0 0 .51 1.58c.25.23.15.46-.14.57-.47.17-.49.46-.35.9.29.92.26.94-.69 1-.42 0-.71.12-.82.58a1.41 1.41 0 0 1-.31.56 4.69 4.69 0 0 0-.84 2.82h2.09a1.39 1.39 0 0 1 1.32 1.4c0 .44.3.57.65.61a3.14 3.14 0 0 0 .67 0c-.17-1-.38-2-.48-2.91-.12-1.19-.2-2.39-.21-3.59a1.65 1.65 0 0 1 .71-1.46c0 .08.06.11.06.15.13 1 .17 1 1.15 1a2.38 2.38 0 0 1 1.61 1 4.57 4.57 0 0 0-1.09.68 3.7 3.7 0 0 0-.5 1.11h1c1 0 1-.05 1.18.92.66.1 1.46-.08 1.89.61a3.35 3.35 0 0 1 .34 1.29c-.59-.91-1.24-.33-1.89-.19 0 .38 0 .75.06 1.13a1.11 1.11 0 0 1-.63 1.01.68.68 0 0 0-.25.47 9.15 9.15 0 0 0 0 1.17c0 .65-.11.83-.74.93l-.76.12v1a.93.93 0 0 1-.51.88 2.92 2.92 0 0 0-1 4.09c-.57 0-.92-.11-1-.64C36.6 39.28 36 39 35.08 39a9.86 9.86 0 0 1-1.41-.23A2 2 0 0 0 31.23 41a3.15 3.15 0 0 0 1 2.18 2.83 2.83 0 0 0 .79.41.32.32 0 0 0 .31-.12c.15-.67.62-.7 1.17-.6a1.78 1.78 0 0 0 .31 0l-.33 1.45.86.11c.48.09.65.28.64.77a4.48 4.48 0 0 0 .34 2.27c-1.39-.07-1.34-1.14-1.54-2.1-.35 0-.71 0-1.06.08-.77.07-1 0-1.11-.84l-1.45.09A1.07 1.07 0 0 1 30 44a.56.56 0 0 0-.34-.25c-.79-.19-.89-.23-.93-1a1.39 1.39 0 0 0-1.05-1.43 4.93 4.93 0 0 1-.46-.23 1.49 1.49 0 0 1-1-1.29v-.09c.09-1.36-.8-2.26-1.52-3.24a1.25 1.25 0 0 0-.3-.26 3.85 3.85 0 0 1-1.54-2.71 1.56 1.56 0 0 1 1-1.73.55.55 0 0 0 .24-.33 7.45 7.45 0 0 1 .22-1 2.52 2.52 0 0 0 0-2.1.79.79 0 0 1 .08-.84 3.59 3.59 0 0 0 .31-.62c.17-.43.08-.64-.33-.84a.79.79 0 0 0-.28-.04c-.69 0-.85-.48-1-1.06-.29-1.19-.32-1.19-1.56-1.29l-1.16-.1a2.63 2.63 0 0 1 .15-.33 8 8 0 0 1 2-2.27 3.89 3.89 0 0 1 1-.56 1.32 1.32 0 0 1 1.73.64 12 12 0 0 1 .56 1.59.75.75 0 0 0 .28.37c.51.29 1 .55 1.57.83s.59.21.81-.25.41-.95.62-1.43c.05 0 .08 0 .09.06.34.88.34.87 1.27.82L31 23a.58.58 0 0 1 .63.53 4.44 4.44 0 0 0 .15.63 1.35 1.35 0 0 0 1.32.84 1.41 1.41 0 0 0 1.24-1.11c.17-.74.37-1.48.51-2.23a2.64 2.64 0 0 0-.15-.77l-.48.35c-.16-.72.07-1.29.61-1.48a1.7 1.7 0 0 1 1.96 1.1zm1.04-.24a5.82 5.82 0 0 1 .68-1.15 14.53 14.53 0 0 1 1.12-.93 1.11 1.11 0 0 1 .9 0 3.89 3.89 0 0 1 1.15.58 1.72 1.72 0 0 0 1.16.37c.43 0 .61.16.6.58v.75h.76c.36 0 .55.14.54.51a2 2 0 0 0 0 .35c.08.36 0 .61-.39.75a.79.79 0 0 0-.5.87c0 .48.07.95.12 1.46-.38.07-.83-.09-.92.32-.33-.16-.65-.31-1-.49a.45.45 0 0 1-.2-.27c-.07-.6-.06-.6-.68-.63h-.26v-.63c0-.39-.15-.62-.56-.58s-.58-.09-.59-.52a.9.9 0 0 0-.72-.87z"/>'
  },
  help: {
    viewBox: '0 0 52.5 70',
    path: '<path d="M10.2 23.65a11.83 11.83 0 0 1 2-6.29 15.24 15.24 0 0 1 5.8-5.27A18.3 18.3 0 0 1 26.92 10a19 19 0 0 1 8.36 1.75 13.54 13.54 0 0 1 5.6 4.75 11.62 11.62 0 0 1 2 6.53 10.08 10.08 0 0 1-1.12 4.86 14.81 14.81 0 0 1-2.68 3.61c-1 1-2.89 2.72-5.57 5.11a24.68 24.68 0 0 0-1.78 1.78 7.64 7.64 0 0 0-1 1.4 6.83 6.83 0 0 0-.51 1.28c-.12.42-.3 1.17-.54 2.23-.41 2.27-1.71 3.4-3.88 3.4a4 4 0 0 1-2.86-1.11 4.37 4.37 0 0 1-1.16-3.3A11.62 11.62 0 0 1 24.86 34q1.41-1.51 3.79-3.6c1.39-1.22 2.4-2.14 3-2.76a9.4 9.4 0 0 0 1.57-2.08 5 5 0 0 0 .64-2.48 5.74 5.74 0 0 0-2-4.4 7.06 7.06 0 0 0-5-1.8c-2.39 0-4.16.6-5.29 1.81A14.45 14.45 0 0 0 18.76 24c-.74 2.46-2.15 3.69-4.21 3.69a4.15 4.15 0 0 1-3.09-1.29 3.94 3.94 0 0 1-1.26-2.75zm15.94 35.78a5.14 5.14 0 0 1-3.48-1.29 4.52 4.52 0 0 1-1.49-3.6 4.62 4.62 0 0 1 1.44-3.46 4.84 4.84 0 0 1 3.53-1.41A4.8 4.8 0 0 1 31 54.54a4.56 4.56 0 0 1-1.47 3.59 5 5 0 0 1-3.39 1.3z"/>'
  },
  hidden: {
    viewBox: '0 0 78 70',
    path: '<path d="M39.1 47.45a13.2 13.2 0 0 0 4.95-1L39.61 42h-.51a8.09 8.09 0 0 1-8.1-8 4.21 4.21 0 0 1 0-.5L26.6 29a13 13 0 0 0-1 4.94 13.51 13.51 0 0 0 13.5 13.51z"/><path d="M39.07 13.71a31.36 31.36 0 0 0-9.6 1.5L35.29 21a13 13 0 0 1 3.81-.57A13.5 13.5 0 0 1 52.6 34a13 13 0 0 1-.6 3.77l8.29 8.29A31.83 31.83 0 0 0 68.76 34a31.9 31.9 0 0 0-29.69-20.29zM15.54 9.66l-4.15 4.14 7.33 7.33c-.26.22-.53.43-.78.65A31.94 31.94 0 0 0 9.41 34 31.87 31.87 0 0 0 49.9 52.31l9.35 9.35 4.14-4.14zM39.1 47.45A13.51 13.51 0 0 1 25.6 34a13 13 0 0 1 1-4.94l4.4 4.39a4 4 0 0 0 0 .5 8.09 8.09 0 0 0 8.1 8.1h.51l4.44 4.44a13.2 13.2 0 0 1-4.95.96z"/><path d="M40.22 26l6.92 6.93A8.08 8.08 0 0 0 40.22 26z"/>'
  },
  hidden_st: {
    viewBox: '0 0 79 70',
    path: '<path d="M59.63 25.6a59.4 59.4 0 0 1 10.62 9.9S56.52 52.83 39.58 52.83a27.3 27.3 0 0 1-8-1.24M19.5 45.37A58.75 58.75 0 0 1 8.92 35.5s13.72-17.33 30.66-17.33a26.94 26.94 0 0 1 6.68.86M28.92 35.5a10.67 10.67 0 0 1 10.66-10.67M50.25 35.5a10.67 10.67 0 0 1-10.67 10.67m26-36.67l-52 52"/>'
  },
  info: {
    viewBox: '0 0 42 70',
    path: '<path d="M27.1 9.5a4.86 4.86 0 0 1 5.22 5.09 6.84 6.84 0 0 1-7 6.53c-3.3 0-5.23-1.95-5.13-5.17A6.69 6.69 0 0 1 27.1 9.5zm-10.72 52c-2.75 0-4.77-1.7-2.84-9.16l3.15-13.24c.55-2.12.64-3 0-3-.82 0-4.39 1.47-6.5 2.91l-1.37-2.26c6.68-5.68 14.38-9 17.68-9 2.75 0 3.2 3.31 1.83 8.39l-3.61 13.91c-.64 2.46-.37 3.31.27 3.31.83 0 3.53-1 6.19-3.15l1.56 2.13C26.23 59 19.13 61.5 16.38 61.5z"/>'
  },
  info_square_st: {
    viewBox: '0 0 70 70',
    path: '<rect width="52" height="52" x="9" y="9.5" rx="15.5" ry="15.5"/><path d="M35.08 25.39v-1.45m0 23.84V33.33"/>'
  },
  info_st: {
    viewBox: '0 0 43 70',
    path: '<path d="M27.4 9.5a5.05 5.05 0 0 1 5.42 5.28 7.1 7.1 0 0 1-7.23 6.78c-3.42 0-5.42-2-5.32-5.37A6.93 6.93 0 0 1 27.4 9.5zm-11.13 52c-2.85 0-4.95-1.76-2.95-9.51l3.28-13.74c.57-2.2.66-3.08 0-3.08-.86 0-4.56 1.52-6.75 3l-1.43-2.36c6.94-5.9 14.93-9.35 18.35-9.35 2.86 0 3.33 3.43 1.91 8.71l-3.75 14.44c-.67 2.56-.38 3.44.28 3.44.86 0 3.66-1.06 6.42-3.26L33.25 52c-6.75 6.86-14.13 9.5-16.98 9.5z"/>'
  },
  io_st: {
    viewBox: '0 0 67 70',
    path: '<path d="M42.33 12.9a25.26 25.26 0 1 1-19.76.1m10.51-3.5v27.21"/>'
  },
  lasso: {
    viewBox: '0 0 80 70',
    path: '<path d="M68.72 44.71L42 31.33a1 1 0 0 0-1.16.19 1 1 0 0 0-.19 1.16L54 59.45a1 1 0 0 0 .9.55h.1a1 1 0 0 0 .87-.75l2.53-10.13 10.12-2.53a1 1 0 0 0 .2-1.88zM21 33.91a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm1.36 8.33a2.72 2.72 0 1 1 1-3.71 2.72 2.72 0 0 1-.97 3.71z"/><path d="M17.33 41.25A1.47 1.47 0 0 0 15.87 43a6.41 6.41 0 0 1-.72 4.59 8.25 8.25 0 0 1-4.22 3.32 1.46 1.46 0 0 0-.78 2 1.48 1.48 0 0 0 1.81.75 12 12 0 0 0 4.16-2.32A8.8 8.8 0 0 0 19 44.88a9.51 9.51 0 0 0-.2-2.46 1.45 1.45 0 0 0-1.4-1.17zM37.6 10c-15 0-27.17 8-27.17 17.93 0 5 3.08 9.5 8.05 12.75a2.9 2.9 0 0 1-.11-.79 2.72 2.72 0 0 1 2.52-2.71c-3.79-2.42-6.11-5.67-6.11-9.25 0-7.5 10.22-13.58 22.82-13.58s22.83 6.08 22.83 13.58S50.21 41.52 37.6 41.52a33.52 33.52 0 0 1-14.12-2.92 2.83 2.83 0 0 1 .32 1.29 2.73 2.73 0 0 1-2 2.63 37.26 37.26 0 0 0 15.8 3.35c15 0 27.18-8 27.18-17.94S52.61 10 37.6 10z"/>'
  },
  layers: {
    viewBox: '0 0 69 70',
    path: '<circle cx="51.12" cy="33.61" r="0.95"/><circle cx="17.02" cy="33.61" r="0.95"/><circle cx="19.86" cy="36.46" r="0.95"/><circle cx="25.54" cy="36.46" r="0.95"/><circle cx="22.7" cy="39.31" r="0.95"/><circle cx="28.38" cy="39.31" r="0.95"/><circle cx="31.23" cy="42.17" r="0.95"/><circle cx="36.91" cy="42.17" r="0.95"/><circle cx="39.75" cy="39.31" r="0.95"/><circle cx="34.07" cy="45.02" r="0.95"/><circle cx="42.59" cy="36.46" r="0.95"/><circle cx="48.28" cy="36.46" r="0.95"/><circle cx="45.44" cy="39.31" r="0.95"/><path d="M51.63 40.09l6.61-3.79a1.51 1.51 0 0 0 0-2.62l-6.86-3.9 6.87-3.94a1.51 1.51 0 0 0 0-2.61L35.74 10.39a2.55 2.55 0 0 0-2.48 0l-22.5 12.84a1.51 1.51 0 0 0 0 2.61l6.87 3.94-6.85 3.9a1.52 1.52 0 0 0 0 2.63l6.85 3.93-6.86 3.91a1.5 1.5 0 0 0 0 2.61l22.5 12.91a2.49 2.49 0 0 0 2.48 0l22.5-12.91a1.51 1.51 0 0 0 0-2.62l-6.86-3.9h.07zM34.75 12l21.72 12.4a.16.16 0 0 1 0 .27l-7 4-14.72 8.45a.5.5 0 0 1-.5 0L12.53 24.67a.16.16 0 0 1 0-.27L34.25 12a.5.5 0 0 1 .5 0zM19 31.17a1 1 0 0 0 .85.54.94.94 0 0 0 .65-.27l2.15 1.23a1 1 0 0 0-.91.94 1 1 0 1 0 1.9 0 .87.87 0 0 0-.13-.45l9.79 5.62a.9.9 0 0 0-.19.53 1 1 0 1 0 1.9 0 .61.61 0 0 0 0-.13l9.52-5.46a.94.94 0 1 0 1.47-.86l2.08-1.19a1.42 1.42 0 0 0 .2 0 1 1 0 0 0 .89-.66l.3-.18 7 4a.16.16 0 0 1 0 .27l-1.65.94a.94.94 0 0 0-.86-.56 1 1 0 0 0-1 1 .91.91 0 0 0 .19.54l-3.73 2.14-6.06 3.48a.9.9 0 0 0 .13-.45.95.95 0 1 0-1 .94l-2.14 1.23a.92.92 0 0 0-.66-.27.94.94 0 0 0-.94 1 .71.71 0 0 0 0 .21l-3.6 2.07a1.47 1.47 0 0 1-1.49 0l-4.48-2.57a1 1 0 0 0-.89-.66.65.65 0 0 0-.2 0l-2.08-1.2a.94.94 0 1 0-1.49-.85l-9.43-5.49a.7.7 0 0 0 0-.14 1 1 0 0 0-.95-1 .92.92 0 0 0-.58.22L12.3 35zm37.47 14.42L35.25 57.76a1.49 1.49 0 0 1-1.5 0L12.53 45.59a.16.16 0 0 1 0-.27l7-4 13.73 7.88a2.49 2.49 0 0 0 2.48 0l13.73-7.88 7 4a.15.15 0 0 1 0 .27z"/>'
  },
  list_st: {
    viewBox: '0 0 74 70',
    path: '<path d="M27.91 9.5h37.14v12.38H27.91zm0 19.81h37.14v12.38H27.91zm0 19.81h37.14V61.5H27.91zM8.1 9.5h12.38v12.38H8.1zm0 19.81h12.38v12.38H8.1zm0 19.81h12.38V61.5H8.1z"/>'
  },
  locate: {
    viewBox: '0 0 70 70',
    path: '<circle cx="35.6" cy="35.5" r="4.52"/><path d="M50.29 45.67L61.6 35.5 50.29 25.33v20.34zM20.9 25.33L9.6 35.5l11.3 10.17V25.33zm24.87-4.53L35.6 9.5 25.42 20.8h20.35zM25.42 50.2L35.6 61.5l10.17-11.3H25.42z"/>'
  },
  lock: {
    viewBox: '0 0 58 70',
    path: '<path d="M43.3 27.08H41v-4.7a11.76 11.76 0 0 0-23.52 0v4.7h-2.4a4.72 4.72 0 0 0-4.7 4.71V55.3a4.72 4.72 0 0 0 4.7 4.7H43.3a4.72 4.72 0 0 0 4.7-4.7V31.79a4.72 4.72 0 0 0-4.7-4.71zM29.19 48.24a4.7 4.7 0 1 1 4.7-4.7 4.71 4.71 0 0 1-4.7 4.7zm7.29-21.16H21.9v-4.7a7.29 7.29 0 1 1 14.58 0z"/>'
  },
  logo_st: {
    viewBox: '0 0 75 70',
    path: '<circle cx="18.69" cy="19.59" r="10.08"/><circle cx="55.72" cy="26.41" r="10.08"/><circle cx="32.42" cy="51.41" r="10.08"/><path d="M39.1 43.86l9.67-10.15m-2.95-9.12l-8.72-1.61m-14.33 5.83l2.67 6.26"/>'
  },
  magic_wand: {
    viewBox: '0 0 81 70',
    path: '<path d="M46.45 15.34L10 51.3 20.71 62l36.44-36zM50 26l-3.57 3.57L42.88 26l3.57-3.57zm-.76 13h2.7v2.7h-2.7zM38.02 9.94h5.05v5.05h-5.05zM62.5 13.5h4V26h-4z"/><path d="M70.75 17.75v4h-12.5v-4zM61.47 32h2.56v8h-2.56z"/><path d="M66.75 34.72v2.56h-8v-2.56z"/>'
  },
  menu: {
    viewBox: '0 0 77 70',
    path: '<path d="M9 53h59v8H9zm0-22h59v8H9zM9 9h59v8H9z"/>'
  },
  minus_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M61.5 36h-52"/>'
  },
  node_st: {
    viewBox: '0 0 79 70',
    path: '<circle cx="19.44" cy="20.21" r="10.71"/><circle cx="59.42" cy="20.21" r="10.71"/><circle cx="39.9" cy="50.79" r="10.71"/>'
  },
  number: {
    viewBox: '0 0 111 70',
    path: '<path d="M33.66 61.5H23.5V22.34L11.37 26.1v-8.26l21.2-7.6h1.09zm39.53 0H44v-5.8L57.75 41A34 34 0 0 0 62 35.57a8.68 8.68 0 0 0 1.36-4.39 6.49 6.49 0 0 0-1.43-4.47 5.21 5.21 0 0 0-4.1-1.63 5.58 5.58 0 0 0-4.53 2 7.85 7.85 0 0 0-1.65 5.2H43.1a14 14 0 0 1 1.9-7.14 13.06 13.06 0 0 1 5.26-5.05 16 16 0 0 1 7.7-1.83q6.6 0 10.24 3.16t3.65 8.94a14.34 14.34 0 0 1-1.64 6.44 35.55 35.55 0 0 1-5.63 7.65l-9.73 10.22h18.34zM84.3 42.27h3.46A4.87 4.87 0 0 0 91.42 41a4.56 4.56 0 0 0 1.19-3.28 4 4 0 0 0-1.18-3.08 4.59 4.59 0 0 0-3.24-1.1 4.81 4.81 0 0 0-3.13 1 3.26 3.26 0 0 0-1.25 2.66h-6.5a8 8 0 0 1 1.39-4.59 9.24 9.24 0 0 1 3.86-3.18A12.94 12.94 0 0 1 88 28.35c3.46 0 6.17.82 8.13 2.48a8.46 8.46 0 0 1 2.94 6.84 6.89 6.89 0 0 1-1.37 4.13 8.84 8.84 0 0 1-3.59 2.9 8.19 8.19 0 0 1 4.12 3 8 8 0 0 1 1.36 4.68 8.6 8.6 0 0 1-3.18 7A12.79 12.79 0 0 1 88 62a12.12 12.12 0 0 1-8-2.58 8.46 8.46 0 0 1-3.11-6.83h6.51a3.76 3.76 0 0 0 1.38 3 5.75 5.75 0 0 0 7-.06 4.21 4.21 0 0 0 1.32-3.24q0-4.91-5.39-4.9H84.3z"/>'
  },
  pin: {
    viewBox: '0 0 70 70',
    path: '<path d="M24.07 25.58l-2.82 2.59 9.58 9.58-21 21 1.36 1.36 21-21 9.58 9.58 2.59-2.82L43 41.81l12.17-16.23 3.39.68 1.35-1.35-7.44-7.44L45 10l-1.35 1.35.68 3.39-16.2 12.2z"/>'
  },
  pin_st: {
    viewBox: '0 0 70 69',
    path: '<path d="M24 25.22l-2.79 2.54L31 37.54 10.36 58.2l.67.67 20.66-20.66L41.47 48 44 45.21l-1.33-4 12-16 3.33.66 1.34-1.33L52 17.22l-7.31-7.33-1.34 1.33.65 3.33-16 12z"/>'
  },
  plus_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M60.21 35.5h-52m26-26v52"/>'
  },
  redo: {
    viewBox: '0 0 91 70',
    path: '<path d="M52.5 23.37S9.17 18.17 9.17 61.5C23 35.5 52.5 44.17 52.5 44.17V58L82 33.77 52.5 9.5z"/>'
  },
  reduce_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M38.47 31.22l22.6-22.6m-52 52l22.61-22.61m22.61-6.79H38.47V15.4m-6.79 38.43V38.01H15.86"/>'
  },
  reload: {
    viewBox: '0 0 56 70',
    path: '<path d="M10 36a18 18 0 0 0 2.82 9.68l3.31-3.32A13.32 13.32 0 0 1 14.55 36a13.64 13.64 0 0 1 13.63-13.62v6.81l9.09-9.09-9.09-9.1v6.82A18.17 18.17 0 0 0 10 36zm18.18 6.82l-9.09 9.09L28.18 61v-6.81a18.14 18.14 0 0 0 15.36-27.86l-3.32 3.32A13.21 13.21 0 0 1 41.81 36a13.64 13.64 0 0 1-13.63 13.64z"/>'
  },
  save_st: {
    viewBox: '0 0 67 70',
    path: '<path d="M8.65 13.63v43.7a4.15 4.15 0 0 0 4.15 4.15h40.73a4.15 4.15 0 0 0 4.15-4.15V22.91a4.14 4.14 0 0 0-1.26-3l-9.59-9.27a4.15 4.15 0 0 0-2.89-1.17H12.8a4.15 4.15 0 0 0-4.15 4.16z"/><circle cx="34.16" cy="44.05" r="6.13"/><path d="M18.34 11.06v8.31a3.16 3.16 0 0 0 3.16 3.16h18.59a3.17 3.17 0 0 0 3.16-3.16v-8.31"/>'
  },
  reload_st: {
    viewBox: '0 0 88 70',
    path: '<path d="M54.29 61.5H26.76a9.17 9.17 0 0 1-9.18-9.18V27.85M32.88 9.5h27.53a9.18 9.18 0 0 1 9.17 9.18v24.47"/><path d="M8.41 33.97l9.17-6.12 9.18 6.12m33.65 3.06l9.17 6.12 9.18-6.12"/>'
  },
  run: {
    viewBox: '0 0 60 70',
    path: '<path d="M10 60V10l40 25-40 25z"/>'
  },
  select_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M9.43 25.75V9.5h16.18m35.82 16.25V9.5H45.25M9.43 45.25V61.5h16.18m35.82-16.25V61.5H45.25"/>'
  },
  select: {
    viewBox: '0 0 70 70',
    path: '<path d="M29.84 56.13h-6.92v-4.5h6.92zm-13.84 0H9.8v-6.19h4.51v1.69H16v4.5zM14.31 43h-4.5v-6.9h4.5zm0-13.84h-4.5v-6.9h4.5zm0-13.82H9.8V9.15H16v4.5h-1.69v1.69zm29.37-1.69h-6.92v-4.5h6.92zm-13.84 0h-6.92v-4.5h6.92zm26.95 1.69h-4.51v-1.69H50.6v-4.5h6.19v6.19zm0 13.84h-4.5v-6.92h4.5zm2.72 16.7L35.66 34a.9.9 0 0 0-1.2 1.2L46.38 59a.9.9 0 0 0 .8.49h.1a.88.88 0 0 0 .77-.67l2.25-9 9-2.26a.88.88 0 0 0 .67-.77.9.9 0 0 0-.46-.91z"/>'
  },
  settings: {
    viewBox: '0 0 70 70',
    path: '<path d="M30.88 9.5l-1.81 6.32a20 20 0 0 0-4.65 1.92l-5.73-3.18-5.13 5.13 3.18 5.73a20 20 0 0 0-1.92 4.65L8.5 31.88v7.24l6.32 1.81a20 20 0 0 0 1.92 4.65l-3.18 5.73 5.13 5.13 5.73-3.18a20 20 0 0 0 4.65 1.92l1.81 6.32h7.24l1.81-6.32a20 20 0 0 0 4.65-1.92l5.73 3.18 5.13-5.13-3.18-5.73a20 20 0 0 0 1.92-4.65l6.32-1.81v-7.24l-6.32-1.81a20 20 0 0 0-1.92-4.65l3.18-5.73-5.13-5.13-5.73 3.18a20 20 0 0 0-4.65-1.92L38.12 9.5zm3.62 14.18A11.82 11.82 0 1 1 22.68 35.5 11.88 11.88 0 0 1 34.5 23.68zm0 7.09a4.73 4.73 0 1 0 4.73 4.73 4.68 4.68 0 0 0-4.73-4.73z"/>'
  },
  settings_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M31.38 9l-1.81 6.32a20 20 0 0 0-4.65 1.92l-5.73-3.18-5.13 5.13 3.18 5.73a20 20 0 0 0-1.92 4.65L9 31.38v7.24l6.32 1.81a20 20 0 0 0 1.92 4.65l-3.18 5.73 5.13 5.13 5.73-3.18a20 20 0 0 0 4.65 1.92L31.38 61h7.24l1.81-6.32a20 20 0 0 0 4.65-1.92l5.73 3.18 5.13-5.13-3.18-5.73a20 20 0 0 0 1.92-4.65L61 38.62v-7.24l-6.32-1.81a20 20 0 0 0-1.92-4.65l3.18-5.73-5.13-5.13-5.73 3.18a20 20 0 0 0-4.65-1.92L38.62 9zM35 23.18A11.82 11.82 0 1 1 23.18 35 11.88 11.88 0 0 1 35 23.18zm0 7.09A4.73 4.73 0 1 0 39.73 35 4.68 4.68 0 0 0 35 30.27z"/>'
  },
  share_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M25.29 31.46a9 9 0 1 0 0 8.08m25.83-11.95a9 9 0 1 0-9-9 8.94 8.94 0 0 0 1 4M43 48.42a9 9 0 1 0 8.08-5"/><path d="M51.12 27.59a9 9 0 0 1-8.08-5l-17.75 8.87a9 9 0 0 1 0 8.08L43 48.42a9 9 0 0 1 8.08-5"/>'
  },
  spin_st: {
    viewBox: '0 0 71 70',
    path: '<circle cx="54.93" cy="24.86" r="7.09"/><circle cx="38.39" cy="15.41" r="5.91"/><circle cx="21.84" cy="20.14" r="5.91"/><circle cx="13.57" cy="34.32" r="4.73"/><circle cx="17.11" cy="48.5" r="4.73"/><circle cx="28.93" cy="57.95" r="3.55"/><circle cx="41.64" cy="58.3" r="2.36"/><circle cx="50.2" cy="54.11" r="1.18"/><circle cx="55.6" cy="48.5" r="1.18"/><path d="M58.48 42.41a.18.18 0 1 1-.18.18.18.18 0 0 1 .18-.18m0-1a1.18 1.18 0 1 0 1.18 1.18 1.18 1.18 0 0 0-1.18-1.18z"/>'
  },
  size: {
    viewBox: '0 0 70 70',
    path: '<circle cx="45.32" cy="26.68" r="15.68"/><circle cx="19.36" cy="42.91" r="11.36"/><circle cx="43.15" cy="54.81" r="7.03"/>'
  },
  spread: {
    viewBox: '0 0 74 70',
    path: '<circle cx="16" cy="34" r="6"/><circle cx="37" cy="34" r="6"/><circle cx="58" cy="34" r="6"/>'
  },
  star_st: {
    viewBox: '0 0 70 70',
    path: '<path d="M37.54 10.8l5.15 13.73A2.26 2.26 0 0 0 44.81 26h14.47a2.25 2.25 0 0 1 1.47 4L48.31 40.64a2.26 2.26 0 0 0-.68 2.43l5.09 15.28a2.26 2.26 0 0 1-3.48 2.53l-12.48-9.15a2.27 2.27 0 0 0-2.67 0l-12.48 9.15a2.26 2.26 0 0 1-3.48-2.53l5.09-15.28a2.26 2.26 0 0 0-.67-2.43L10.1 30a2.26 2.26 0 0 1 1.47-4h14.48a2.25 2.25 0 0 0 2.11-1.47l5.15-13.73a2.26 2.26 0 0 1 4.23 0z"/>'
  },
  string: {
    viewBox: '0 0 126 70',
    path: '<path d="M43.47 51H25l-3.54 10.5H10.25L29.3 10.31h9.77L58.23 61.5H47zm-15.65-8.59h12.8l-6.43-19.16zm62.44 3.53q0 7.62-3.25 11.88a10.76 10.76 0 0 1-9.08 4.27 9.88 9.88 0 0 1-8.23-4l-.39 3.37H61.7v-45h8.46v16.18a9.68 9.68 0 0 1 7.71-3.43A10.88 10.88 0 0 1 87 33.48q3.28 4.26 3.29 12zm-8.47-.61c0-3.21-.5-5.54-1.52-7a5.15 5.15 0 0 0-4.54-2.21 5.59 5.59 0 0 0-5.57 3.31v12.49a5.66 5.66 0 0 0 5.63 3.34 5.23 5.23 0 0 0 5.39-4 21 21 0 0 0 .61-5.93zm23.04 11.39a4.27 4.27 0 0 0 2.92-1 3.5 3.5 0 0 0 1.16-2.63H115a8.18 8.18 0 0 1-1.35 4.52 8.77 8.77 0 0 1-3.65 3.2 11.35 11.35 0 0 1-5.06 1.19 10.56 10.56 0 0 1-8.22-3.31q-3-3.31-3-9.16v-.42c0-3.75 1-6.73 3-9a10.45 10.45 0 0 1 8.2-3.34 10.21 10.21 0 0 1 7.31 2.59 9.17 9.17 0 0 1 2.8 6.91h-6.09a4.5 4.5 0 0 0-1.16-3.08 4.34 4.34 0 0 0-6.39.46c-.78 1.11-1.16 2.9-1.16 5.37v.67q0 3.77 1.14 5.4a4 4 0 0 0 3.46 1.63z"/>'
  },
  style: {
    viewBox: '0 0 78 70',
    path: '<path d="M63.69 10a2.83 2.83 0 0 0-3.87 0L38.44 25.52a2.83 2.83 0 0 0-.24 4l.15.16 9 9a2.83 2.83 0 0 0 2 .85h.1a2.83 2.83 0 0 0 2.07-.94l16.33-20.71a2.82 2.82 0 0 0-.09-3.88zM49.21 32.51l-4.72-4.72L51 22l4 4zm-13.79.66a2.87 2.87 0 0 0-2-.85c-3.4 0-9.73 1.52-14.07 11.91-2.54 6.14-6.7 8.68-7.65 9a2.84 2.84 0 0 0-.85 5.48 37.89 37.89 0 0 0 12.75 2.55 20.38 20.38 0 0 0 9.92-2.37c5.2-2.83 8.6-8.12 10.3-15.68a2.84 2.84 0 0 0-.76-2.64z"/>'
  },
  subgraph_st: {
    viewBox: '0 0 80 70',
    path: '<circle cx="19.59" cy="20.21" r="10.71"/><circle cx="59.57" cy="20.21" r="10.71"/><circle cx="40.05" cy="50.79" r="10.71"/><path d="M45.81 41.77L53.96 29m-23.67-8.79h19.05"/>'
  },
  swap_st: {
    viewBox: '0 0 77 69',
    path: '<path d="M22.82 59L9.6 45.68l13.22-13.41m42.7 13.51H10.67M53.78 10L67 23.32 53.78 36.73m-42.7-13.51h54.85"/>'
  },
  undo: {
    viewBox: '0 0 91 70',
    path: '<path d="M38.5 23.37s43.33-5.2 43.33 38.13C68 35.5 38.5 44.17 38.5 44.17V58L9 33.77 38.5 9.5z"/>'
  },
  upload: {
    viewBox: '0 0 100 70',
    path: '<path d="M74.28 34.22C73.52 20.66 63 9.9 50 9.9c-9.72 0-18.08 6.1-22 14.82-10-.39-18 8.11-18 18.44 0 16.32 15.65 18.48 15.65 18.48h50.44S90 61.86 90 47.78c0-8.78-7.61-15.36-15.72-13.56zM56.84 37.5V52H44.16V37.5H36L50.5 23 65 37.5z"/>'
  },
  upload_st: {
    viewBox: '0 0 79 70',
    path: '<path d="M50.41 46.36H57s11.86-1.54 11.86-13.16a13.13 13.13 0 0 0-13.64-13.14 18.4 18.4 0 0 0-35 6.76A9.88 9.88 0 0 0 8.3 36.49c0 10 10.54 9.87 10.54 9.87h7.88m11.86-15.14V61.5"/><path d="M46.84 39.48l-8.26-8.26-8.26 8.26"/>'
  },
  users_st: {
    viewBox: '0 0 87 70',
    path: '<ellipse cx="31.13" cy="23.03" rx="13.69" ry="13.53"/><path d="M53.14 61.5a22 22 0 0 0-44 0"/><ellipse cx="61.28" cy="31.41" rx="10.71" ry="10.58"/><path d="M78.5 61.5a17.12 17.12 0 0 0-17.22-17 17.38 17.38 0 0 0-7 1.47"/>'
  },
  user_st: {
    viewBox: '0 0 55 70',
    path: '<circle cx="28" cy="23.03" r="13.53"/><path d="M49.75 61.5a21.75 21.75 0 0 0-43.5 0"/>'
  },
  visible: {
    viewBox: '0 0 78 70',
    path: '<path d="M39.5 15.12A30.56 30.56 0 0 0 11.08 34.5a30.53 30.53 0 0 0 56.84 0A30.56 30.56 0 0 0 39.5 15.12zm0 32.3A12.92 12.92 0 1 1 52.42 34.5 12.93 12.93 0 0 1 39.5 47.42zm0-20.67a7.75 7.75 0 1 0 7.75 7.75 7.74 7.74 0 0 0-7.75-7.75z"/>'
  },
  warning: {
    viewBox: '0 0 70 70',
    path: '<path d="M32.55 43.3h5.2v5.2h-5.2zm0-20.8h5.2v15.6h-5.2zm2.57-13a26 26 0 1 0 26 26 26 26 0 0 0-26-26zm0 46.8A20.8 20.8 0 1 1 56 35.5a20.79 20.79 0 0 1-20.85 20.8z"/>'
  },
  zoom_st: {
    viewBox: '0 0 70 70',
    path: '<circle cx="27.17" cy="27.59" r="18.09"/><path d="M39.96 40.37L61.08 61.5"/>'
  },
  width: {
    viewBox: '0 0 70 70',
    path: '<path d="M9 41h51v21H9zm0-19h51v13H9zm0-12h51v6H9z"/>'
  }
};

export type IconNames =
  'alert'|
  'angle_down'|
  'angle_left'|
  'angle_right'|
  'angle_up'|
  'arrow_down'|
  'arrow_left'|
  'arrow_right'|
  'arrow_up'|
  'check'|
  'close'|
  'code'|
  'collapse'|
  'color'|
  'cursor'|
  'date'|
  'delete'|
  'download'|
  'download_data'|
  'drag'|
  'earth'|
  'edge'|
  'edit'|
  'erase'|
  'erase'|
  'error'|
  'expand'|
  'export'|
  'file_add'|
  'file_download'|
  'file'|
  'filter'|
  'focus'|
  'folder'|
  'folder_add'|
  'folder'|
  'fullscreen'|
  'geo'|
  'help'|
  'hidden'|
  'hidden'|
  'info'|
  'info_square'|
  'info'|
  'io'|
  'lasso'|
  'layers'|
  'list'|
  'locate'|
  'lock'|
  'logo'|
  'magic_wand'|
  'menu'|
  'minus'|
  'node'|
  'number'|
  'pin'|
  'pin'|
  'plus'|
  'redo'|
  'reduce'|
  'reload'|
  'reload'|
  'run'|
  'save'|
  'select'|
  'select'|
  'settings'|
  'settings'|
  'share'|
  'size'|
  'spin'|
  'spread'|
  'star'|
  'string'|
  'style'|
  'subgraph'|
  'swap'|
  'undo'|
  'upload'|
  'upload'|
  'user'|
  'users'|
  'visible'|
  'warning'|
  'width'|
  'zoom';
